/**
 * MIT License
 *
 * Copyright (c) 2025 Chris M. Perez
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

export { tokenize, type Token, type TokenType } from './tokenizer.js';
export { parseTokens } from './parser.js';

import { Effect, pipe } from 'effect';
import { tokenize } from './tokenizer.js';
import { parseTokens } from './parser.js';
import type { DocumentNode } from '../types/ast.js';
import type { ParseError } from '../types/errors.js';

// Tokenize and parse markdown input
export const parse = (input: string): Effect.Effect<DocumentNode, ParseError> =>
	pipe(tokenize(input), Effect.flatMap(parseTokens));

// Tokenize and parse markdown input synchronously
export const parseSync = (input: string): DocumentNode => {
	return Effect.runSync(
		Effect.catchAll(parse(input), () =>
			Effect.succeed({
				_tag: 'Document' as const,
				children: [],
			})
		)
	);
};
